/* eslint eqeqeq: 0*/

/**
 * Take assessment view
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';


import RenderHTML from '../../common/RenderHTML';
import {config} from '../../../config';

// Translation
import translate from '../../translate/Translate';

// Helpers
import { getParam, getUrlSegment } from '../../../helpers';

// Dependencies
import * as Survey from 'survey-react';
import he from 'he';



// Custom Survey Questions
import {
  readingQuestion,
  typingQuestion,
  likertQuestion
} from '../../../customSurveyQuestions';

// Components
import TextToSpeech from '../../common/TextToSpeech';

Survey.Serializer.addProperty('itemValue', { name: 'likert_label', default: '' });
Survey.Serializer.addProperty('itemValue', { name: 'html', default: '' });




const TakeAssessment = observer ( class TakeAssessment extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      attemptSid: null
    };

    // Create TTS holder, keyed by the audio controls id
    this.tts = {};
  }

  componentWillMount() {
    const { UserStore } = this.props.store;

  this.beforeUnloadHandler =     (e) => {
      if(UserStore.userData.role === 'learner'){
      // Cancel the event as stated by the standard.
        e.preventDefault();
      }
      // Unmount all audio controls when the page is refreshed. Otherwise,
      // there's the potential for TTS audio to continue playing even after
      // its controls are gone.
      this.unmountAudioControls();
    }
    window.addEventListener('beforeunload', this.beforeUnloadHandler)
  }

  componentDidUpdate() {
    if (window.MathJax) {
      try {
        window.MathJax.typeset();
      } catch (error) {
        // Handle MathJax error if needed
      }
    }
  }

  componentDidMount() {
    const { history, review, store } = this.props;
    const { AssessmentStore, UserStore } = store;
    const { userData } = UserStore;

    const assessmentSid = getUrlSegment(2);
    const attemptSid = getParam('attempt');
    if (userData && userData.userSid) {
      this.createMetaTag('userSid', userData.userSid);
    }
    if (assessmentSid) {
      this.createMetaTag('assessmentSid', assessmentSid);
    }
    if (attemptSid) {
      this.createMetaTag('attemptSid', attemptSid);
    }

    // If we are reviewing, we need the assessment and the correct version.
    // If there is an attemptSid in the URL, we are continuing an attempt.
    // Otherwise, this is a new attempt that needs to be created.
    if (getParam('attempt') || review) {
      this.setState({
        attemptSid: getParam('attempt')
      });

      // Check if attempt is completed already then
      // Get assessment version from the attempt
      // then get the correct assessment version
      const callback = attempt => {
        if (attempt && attempt.status === 'Completed' && userData.role.toLowerCase() === 'learner') {

          AssessmentStore.getNextRoute(attempt, history)
          return;
        }
        this.getAssessmentData(attempt);
        this.storeResponses(attempt.responseJson);
      };

      AssessmentStore.getAttempt(getParam('attempt'), callback);
    } else if (getParam('groupItem')) {
      // Check if attempt exists, if not, create one
      const query = {
        assessmentSid: getUrlSegment(2),
        userSid: userData.userSid,
        completionState: 'all-incomplete',
        groupItemSid: getParam('groupItem')
      };

      const callback = attempts => {
        if (attempts.length > 0) {
          history.push(
            `/assessment/${getUrlSegment(2)}?attempt=${attempts[0].attemptSid}`
          );
        } else {
          this.createAttempt();
        }
      };

      AssessmentStore.listAttempts(query, callback);
    }
  }

  componentWillUnmount() {
    // Unmount ReactDOM rendered TextToSpeech components
    this.unmountAudioControls();
  }

  createMetaTag(type, sid) {
    const meta = document.createElement('meta');
    meta.name = type;
    meta.content = sid;

    const head = document.querySelector('head');
    if (head) {
      head.appendChild(meta);
    }
  }

  createAttempt = () => {
    const { history, store } = this.props;
    const { AssessmentStore, UserStore } = store;
    const { userData } = UserStore;

    const payload = [
      {
        groupItemSid: getParam('groupItem'),
        userSid: userData.userSid,
        enrollmentSid: userData.enrollmentSid
      }
    ];

    const callback = attemptSid => {
      this.setState({
        attemptSid
      });

      AssessmentStore.getAttempt(attemptSid, this.getAssessmentData);
      history.push(`/assessment/${getUrlSegment(2)}?attempt=${attemptSid}`);
    };

    AssessmentStore.createAttempt(payload, callback);
  };

  getAssessmentData = attempt => {
    const { review, store } = this.props;
    const { AssessmentStore } = store;
    const assessmentSid = getUrlSegment(2);
    const query = {
      assessmentVersionSid: attempt.assessmentVersionSid
    };

    if(review) {
      query.displayMode = 'single-page';
      query.review = true;
    }

    AssessmentStore.getAssessment(assessmentSid, query);
    console.log(AssessmentStore.submissionConfirmation)
  };

  storeResponses = async responseJson => {
    const response = {};

    if (responseJson && Object.keys(responseJson).length > 0) {
      Object.keys(responseJson).forEach(question => {
        if(responseJson[question].response && !responseJson[question].secondsElapsed) {
          response[question] = responseJson[question].response;
        } else {
          response[question] = responseJson[question];
        }
      });
    }

    this.setState({
      response,
      formattedResponse: responseJson
    });

    return true;
  };

handleSubmit = (surveyResponse, complete, backgroundLoad, saveCallback) => {
    const { attemptSid } = this.state;
    const { AssessmentStore } = this.props.store;

    const responseJson = {};
    const removeableProps = [];

    // Store the surveyResponse in case the
    // user clicks the save button
    this.setState({
      surveyResponse
    });

    Object.keys(surveyResponse.data).forEach(question => {
      if(surveyResponse.data[question]?.secondsElapsed) {
        responseJson[question] = surveyResponse.data[question];
      } else {
        responseJson[question] = {
          response: surveyResponse.data[question]
        };
      }

      // Handle comments
      if (surveyResponse.data[`${question}-Comment`]) {
        responseJson[question].comment = surveyResponse.data[`${question}-Comment`];
        removeableProps.push(`${question}-Comment`);
      }
    });

    if (removeableProps.length) {
      removeableProps.forEach(key => {
        delete responseJson[key];
      });
    }

    const payload = {
      responseJson,
      finalSubmission: false,
      userAgent: navigator.userAgent
    };

    let callback = response => {
      this.storeResponses(response.responseJson);

      if(saveCallback) {
        saveCallback();
      }
    };

    if (complete) {
      payload.finalSubmission = true;
      callback = this.complete;
    }

    AssessmentStore.saveAttempt(attemptSid, payload, callback, backgroundLoad);
  };

confirmComplete = (surveyResponse, options) => {
    const { store, translation } = this.props;
    const { AppStore } = store;

    options.allowComplete = false;

    AppStore.showDialog(translation.complete_confirm, 'confirm', () => {
      this.handleSubmit(surveyResponse, true);
    });
  };

complete = (data = null) => {

    const { history } = this.props;
    const { AssessmentStore } = this.props.store;

    AssessmentStore.getNextRoute(data, history)
  };

  isCorrect = question => {
    // Using == instead of === because SurveyJS isn’t exactly consistent when it comes to numbers/strings
    if (question.correctAnswer !== undefined) {
      return question.value == question.correctAnswer;
    }

    return 'n/a';
  };

  renderMathJax = () => {
    if (window.MathJax) {
      try {
        window.MathJax.typeset();
      } catch (error) {
        // Ignore MathJax retry error which is non-breaking
      }
    }
  };

  renderSave = () => {
    const { translation, store } = this.props;
    let nav;

    const appInstallSid = getParam('install') || store?.UserStore?.installSid;
    if (appInstallSid && config.customRedirectInstalls.includes(appInstallSid)) {
      return;
    }

    const saveDelay = setInterval(() => {
      nav = document.querySelector('.sv_nav');

      if(nav && !document.querySelector('.sfl-btn')) {
        clearInterval(saveDelay);

        const saveBtn = document.createElement('button');
        saveBtn.textContent = translation.save.button;
        saveBtn.className = 'btn btn--outline sfl-btn'
        saveBtn.onclick = this.handleSave;

        nav.insertBefore(saveBtn, nav.lastChild);
      }
    }, 100);
  }

  handleSave = () => {
    const { store, translation } = this.props;
    const { surveyResponse } = this.state;
    const { AppStore } = store;

    const callback = () => {
      AppStore.showDialog(translation.save.success);
    };

    this.handleSubmit(surveyResponse, false, true, callback);
  }

  renderAudioControls = (parent, id) => {
    const { translation } = this.props;

    this.tts[id] = parent.querySelector('.rate-question__audio');

    ReactDOM.render(
      <TextToSpeech
        {...this.props}
        className="rate-question__tts"
        id={id}
        label={translation.rate_question.label}
        text={parent.querySelector('.rate-question__passage').innerText}
      />,
      parent.querySelector('.rate-question__audio')
    );
  }

  /**
   * unmountAudioControls
   * @param {string} [id] - The specific TTS component to unmount.
   * If no ID is provided, unmount all audio controls.
   */
  unmountAudioControls = (id) => {
    // Unmount ReactDOM rendered TextToSpeech components

    if(id) {
      ReactDOM.unmountComponentAtNode(this.tts[id]);
    } else {
      Object.keys(this.tts).forEach(id => {
        ReactDOM.unmountComponentAtNode(this.tts[id]);
      });
    }
  }

  render() {
    const { response } = this.state;
    const { review, store, translation } = this.props;
    const { AppStore, AssessmentStore } = store;
    const { assessment } = AssessmentStore;
    const appInstallSid = getParam('install') || store?.UserStore?.installSid;

    if (!AppStore.loading && assessment) {
      // Custom question types
      typingQuestion(Survey);
      readingQuestion(Survey);
      likertQuestion(Survey);

      // Create the Survey model
      const model = new Survey.Model(assessment.assessmentJson);

      model.getAllQuestions().forEach(function(question) {
        // We made the decision to switch booleans to use 2 choices instead of building them using value/labels, this just helped the logic of the survey builder and this logic accommodates the booleans for surveyJS
        if (question.getType() === "boolean" && question.choices && question.choices.length === 2) {
          question.valueFalse = question.choices[0].value;
          question.valueTrue = question.choices[1].value;
          question.labelFalse =  question.choices[0].text;
          question.labelTrue = question.choices[1].text;
        }
      });

      // --------------- begin custom rendering -------------------
      if (appInstallSid && config.customRedirectInstalls.includes(appInstallSid)) {
        // Do not render page title for compass tool
      } else {
        model.onAfterRenderPage.add((survey, page) => {
          const pageTitle = page.htmlElement.querySelector('h4.sv_page_title');
          if (pageTitle) {
            // SurveyJS makes the page's title an H4. This is a hack to tell
            // screen readers to treat the h4 like an h1.
            pageTitle.setAttribute("role", "heading");
            pageTitle.setAttribute("aria-level", "1");
            pageTitle.setAttribute("id", "page-title");
          }
          if (pageTitle.innerText.length <= 0) {
            pageTitle.innerText = assessment.name;
          }

          let nav = document.querySelector('.sv_nav');
          let saveBtn = document.querySelector('.sfl-btn');
          if (nav && saveBtn) {
            nav.insertBefore(saveBtn, nav.lastChild);
          }

          // Unmount TTS between page loads, otherwise there's the potential
          // for audio to keep playing after the user navigates away.
          if(Object.keys(this.tts).length) {
            this.unmountAudioControls();
          }
        })
      }
      // Handle custom rendering
      model.onAfterRenderQuestion.add((survey, options) => {
        const questionTitle = options.htmlElement.querySelector('h5');
        let questionText = null;
        let questionNumber = null;
        let textString = null;

        if (questionTitle) {
          questionText = questionTitle.querySelector('span:not([class])');
          questionNumber = questionTitle.querySelector('.sv_q_num');
          questionNumber.innerText += '.';
        }

        if (questionText) {
          // Remove all HTML encoding from the question.
          textString = he.decode(questionText.innerHTML);
          ReactDOM.render(<RenderHTML rawHTML = {textString}></RenderHTML>, questionText)
        }

        // Parse any HTML in the question title


        // Modify the markup of the question title
        // because SurveyJS’s markup is just astounding
        if (questionTitle) {
          const question = options.htmlElement;
          question.className += ' question';

          const questionHead = options.htmlElement.querySelector(
            ':scope > div:first-child'
          );
          questionHead.className += ' question__head';

          questionTitle.outerHTML = `
            <legend class="${questionTitle.className} question__title"></legend>
          `;

          // Question heading H2 markup
          const questionLabel = options.htmlElement.querySelector('.question__title');
          const questionNumberHeading = document.createElement('h2');
          questionNumberHeading.append(questionNumber);
          questionLabel.append(questionText);

          question.prepend(questionLabel);

          const questionAnswer = options.htmlElement.querySelector(
            ':scope > div:last-of-type'
          );
          questionAnswer.className += ' question__answer';

          const questionLegend = questionAnswer.querySelector('legend');

          if (questionLegend) {
            questionLegend.remove();
          }

          // Question Fieldset markup
          const fieldset = document.createElement('fieldset');
          fieldset.append(questionLabel);
          fieldset.append(questionHead);
          fieldset.append(questionAnswer);

          question.append(questionNumberHeading);
          question.append(fieldset);

          // Check for any empty headings
          // which SurveyJS loves to add
          const headings = document.querySelectorAll('h3, h5');

          headings.forEach(heading => {
            if (!heading.textContent) {
              heading.remove();
            }
          });
        }

        // Hide the Likert style question's placeholder. Should only be
        // removed from the Assessment view, not the Survey creator, because
        // otherwise it breaks the Likert rendering in Survey creator.
        const likertPlaceholder = document.querySelectorAll('.likert-placeholder');
        likertPlaceholder.forEach(placeholder => (placeholder.style.display = 'none'));

        // Render typing and reading questions
        if (
          options.question.getType() === 'typingquestion' ||
          options.question.getType() === 'readingquestion'
        ) {
          if (getUrlSegment(1) !== 'assessment-review') {
            const parent = options.htmlElement.querySelector('.rate-question');

            const instructions = document.createElement('span');
            instructions.setAttribute('aria-live', 'assertive');
            instructions.id = `instructions-${options.question.id}`;
            instructions.className = 'meta';

            let secondsElapsed = 0;
            let timer;

            if (parent) {
              parent.append(instructions);
              const responseField = parent.querySelector('.rate-question__response');

              const startBtn = document.createElement('button');
              startBtn.className = 'rate-question__start btn btn--full';

              if (options.question.getType() === 'typingquestion') {
                startBtn.textContent = translation.typing_question.start;
              } else {
                startBtn.textContent = translation.reading_question.start;
              }

              const stopBtn = document.createElement('button');
              stopBtn.className = 'rate-question__stop btn btn--full';
              stopBtn.textContent = translation.typing_question.stop;

              if (options.question.getType() === 'typingquestion') {
                stopBtn.textContent = translation.typing_question.stop;
              } else {
                stopBtn.textContent = translation.reading_question.stop;
              }

              // Prevent pasting in response field
              if (responseField) {
                responseField.addEventListener('paste', e => {
                  e.preventDefault();
                });
              }

              // Start
              startBtn.onclick = () => {
                parent.classList.add('rate-question--active');

                if (options.question.getType() === 'typingquestion') {
                  instructions.textContent = translation.typing_question.aria_live_start;
                } else {
                  instructions.textContent = translation.reading_question.aria_live_start;
                }

                timer = setInterval(() => {
                secondsElapsed++;
                }, 1000);

                parent.append(stopBtn);

                this.renderAudioControls(parent, options.question.id);

                if(responseField) {
                  responseField.value = '';
                }
              };

              // Finish typing
              stopBtn.onclick = () => {
                clearInterval(timer);
                this.unmountAudioControls(options.question.id);

                parent.classList.remove('rate-question--active');
                parent.classList.add('rate-question--complete');

                const msg = document.createElement('span');
                msg.className = 'rate-question__complete-msg note';
                msg.textContent = translation.typing_question.completed;

                if (options.question.getType() === 'typingquestion') {
                  msg.textContent = translation.typing_question.completed;
                  instructions.textContent = translation.typing_question.aria_live_end;
                } else {
                  msg.textContent = translation.reading_question.completed;
                  instructions.textContent = translation.reading_question.aria_live_end;
                }

                parent.append(msg);

                const responseJson = { ...this.state.formattedResponse };

                responseJson[options.question.name] = {
                  secondsElapsed
                };

                if (responseField) {
                  responseJson[options.question.name].response = responseField.value;
                }

                const payload = {
                  responseJson,
                  finalSubmission: false,
                  userAgent: navigator.userAgent
                };

                const callback = response => {
                  this.storeResponses(response.responseJson);
                };

                AssessmentStore.saveAttempt(
                  this.state.attemptSid,
                  payload,
                  callback,
                  true
                );
              };

              parent.prepend(startBtn);
              parent.append(stopBtn);
            }
          } else {
            if (!response) {
              return;
            }

            const studentResponse = response[options.question.name].response;
            const secondsElapsed = response[options.question.name].secondsElapsed;
            const parent = options.htmlElement.querySelector('.rate-question');

            if(options.question.getType() === 'typingquestion') {
              parent.innerHTML = `
                <strong class="rate-question__title-response">${translation.typing_question.student_response}</strong>
                <div class="note"><p>${studentResponse}</p></div>
              `
            }

            parent.innerHTML += `
              <strong class="rate-question__title-response">${translation.time_elapsed.replace('%seconds%', secondsElapsed)}</strong>
            `
          }
        }

        // Loop through all options and decode HTML
        if (options.question.choices) {
          options.question.choices.forEach((choice, i) => {
            const choiceEl = options.htmlElement.querySelectorAll('label')[i];

            if (!choiceEl) {
              return;
            }

            // Remove the input's aria-label since it's not needed.
            // The input is already wrapped in a <label> which contains text.
            choiceEl.firstChild.removeAttribute('aria-label');

            // The label text is contained in the last <span> child.
            // It is not given a class by SurveyJS.
            const choiceText = choiceEl.querySelector('span:not([class])');

            // Decode the choice's innerText.

            if(choice.html){
              ReactDOM.render(<RenderHTML rawHTML = {(choice.html)}></RenderHTML>, choiceText)
            } else {
              choiceText.innerHTML = he.decode(choiceText.innerHTML)
            }
          });
        }

        // If reviewing, show correct answers
        if (
          response &&
          Object.keys(response).length &&
          review
        ) {
          options.htmlElement.className += ' has-response'

          const incorrectTag = document.createElement('em');
          incorrectTag.textContent = translation.incorrect;
          incorrectTag.className = 'sm_sv__tag sm_sv__tag--incorrect';

          const correctTag = document.createElement('em');
          correctTag.textContent = translation.correct;
          correctTag.className = 'sm_sv__tag sm_sv__tag--correct';

          if(Array.isArray(options.question.correctAnswer) && options.question.choices){
            options.question.choices.forEach((choice, i) => {
              let correct = false;
              // if choice is contained in answer array correct is true
              if (Array.isArray(options.question.correctAnswer)) {
                const index = options.question.correctAnswer.findIndex(item => item == choice.itemValue)
                if(index >= 0) correct = true;
              }
              //eslint-disable-next-line
              if(choice.itemValue == options.question.correctAnswer) correct = true;
              const choiceEl = options.htmlElement.querySelectorAll('label')[i];
              if(correct) {
                if(choiceEl) {
                  choiceEl.className += ' sm_sv__correct-choice';
                  choiceEl.append(correctTag);
                }
              } else {
                const incorrectChoice = options.htmlElement.querySelectorAll('input:checked')[i]?.parentNode
                if(incorrectChoice) {
                  choiceEl.append(incorrectTag)
                }
              }
            });
          }

          if(options.question.choices && !Array.isArray(options.question.correctAnswer)) {
            options.question.choices.forEach((choice, i) => {
              //eslint-disable-next-line
              if(choice.itemValue == options.question.correctAnswer) {
                const choiceEl = options.htmlElement.querySelectorAll('label')[i];
                if(choiceEl) {
                  choiceEl.className += ' sm_sv__correct-choice';
                  choiceEl.append(correctTag);
                }
              }
            });
          }

          if(this.isCorrect(options.question) === true) {
            options.htmlElement.className += ' sm_sv__q-correct';
          } else if(this.isCorrect(options.question) === false) {
            options.htmlElement.className += ' sm_sv__q-incorrect';
            const incorrectChoice = options.htmlElement.querySelector('input:checked')?.parentNode
            if(incorrectChoice) {
              incorrectChoice.append(incorrectTag);
            }
          }
        }
      });
      // --------------- end custom rendering -------------------

      return (
        <main
          id="main-content"
          className={`page sm_sv_wrap${review ? ' sm_sv_wrap--readonly' : ''}`}
          tabIndex="-1"
          aria-labelledby="page-title"
        >
          <div className="wrap sm_sv_container">
            { appInstallSid && !config.customRedirectInstalls.includes(appInstallSid) &&
              <Link
                to="/"
                className="back sm_sv_back"
                onClick={review ? () => window.top.close() : null}
              >
                {translation.back}
              </Link>
            }
            { !appInstallSid &&
              <Link
                to="/"
                className="back sm_sv_back"
                onClick={review ? () => window.top.close() : null}
              >
                {translation.back}
              </Link>
            }

            <Survey.Survey
              model={model}
              onAfterRenderPage={(surveyResponse) => {
                this.renderMathJax();
                this.setState({
                  surveyResponse
                }, () => {
                  if(!review) {
                    this.renderSave(surveyResponse);
                  }
                })
              }}
              onCompleting={AssessmentStore.submissionConfirmation ? () => this.confirmComplete : undefined}
              onComplete={surveyResponse => this.handleSubmit(surveyResponse, true)}
              onPartialSend={surveyResponse =>
                this.handleSubmit(surveyResponse, false, true)
              }
              onValueChanged={surveyResponse =>
                this.handleSubmit(surveyResponse, false, true)
              }
              sendResultOnPageNext={true}
              showCompletedPage={false}
              data={response}
              mode={review ? 'display' : ''}
            />
          </div>
        </main>
      );
    }

    return null;
  }
});

export default translate('TakeAssessment')(TakeAssessment);
